import { useLanguage } from "../i18n";

export const PhotoSlot = ({ className = "" }) => {
  const { t } = useLanguage();
  return (
    <div
      data-testid="photo-placeholder"
      className={`relative overflow-hidden ${className}`}
      style={{ backgroundColor: "#391624" }}
    >
      <div className="absolute inset-0 flex items-center justify-center opacity-[0.1]">
        <img src="/logo-mark.png" alt="" className="w-1/2 object-cover" />
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="font-meta text-[10px] uppercase tracking-[0.3em] text-[#C69255]/80">
          {t.photoComingSoon}
        </span>
      </div>
    </div>
  );
};
